export enum AdditionalContentFieldType {
  infoPanel = 'infoPanel',
  statCta = 'statCta',
  chart = 'chart',
}

export type AdditionalContentField = {
  type?: keyof typeof AdditionalContentFieldType;
  label?: string;
  name?: string;
  heading?: string;
  content?: string;
  headingIcon?: string;
  prefix?: string;
};
